/**
 * Created by Daniela on 23/01/2017.
 */
import { Injectable } from '@angular/core';

import { tipoAjustesStorage } from "./data.service";

@Injectable()
export class TipoAjusteService {

    constructor() { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(tipoAjustesStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(tipoAjustesStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(tipoAjustesStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {


    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tipo-ajustes/shared/tipo-ajuste.service.ts
 **/